/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - Portfolio
 * Date: 5/15/21
 * Copyright All Rights Reserved
 */
import { REPAIR_COSTS_ID } from 'constants/performanceMetrics';
import isTimeBasedMetric from './isTimeBasedMetric';

const pickColor = (performanceMetric, value) => {
  if (value === null) {
    return '#999999';
  }
  if (performanceMetric === REPAIR_COSTS_ID) {
    if (value >= 0.4) {
      return '#CB181D';
    }
    if (value >= 0.2) {
      return '#FF0000';
    }
    if (value >= 0.1) {
      return 'orange';
    }
    if (value >= 0.05) {
      return 'yellow';
    }
    return '#46CB18';
  } else if (isTimeBasedMetric(performanceMetric)) {
    if (value >= 365) {
      return '#CB181D';
    }
    if (value >= 182) {
      return '#FF0000';
    }
    if (value >= 28) {
      return 'orange';
    }
    if (value >= 5) {
      return 'yellow';
    }
    return '#46CB18';
  }
  return '#999999';
};

export default pickColor;



// WEBPACK FOOTER //
// ./js/support/pickColor.js